{
  "profiles": [
    {
      "id": "payments-ops",
      "label": { "en": "Payments operations", "ar": "عمليات المدفوعات" },
      "roles": ["payments-ops", "finance-approver"],
      "default_agent": "payments-desk",
      "work_lists": [
        {
          "id": "held-payments",
          "label": { "en": "Payments on hold for my desk", "ar": "مدفوعات موقوفة لمكتبي" },
          "source": "tool",
          "call": { "tool": "payments", "action": "list_held_payments", "args": { "desk": "{user.unit}" } },
          "agent": "payments-desk",
          "open": "record",
          "record": { "type": "payment", "field": "payment_id" },
          "item_label": "{payment_id} · {beneficiary} · {amount} {currency}"
        },
        {
          "id": "release-approvals",
          "label": { "en": "Releases waiting for my approval", "ar": "إفراجات بانتظار اعتمادي" },
          "source": "inbox",
          "filter": { "queue": "finance-approver" },
          "open": "task"
        },
        {
          "id": "disputes",
          "label": { "en": "Open disputes", "ar": "النزاعات المفتوحة" },
          "source": "cases",
          "filter": { "status": "open", "type": "payment_dispute" },
          "agent": "disputes-desk",
          "input": { "case_id": "{item.id}" }
        }
      ],
      "record_types": [
        {
          "type": "payment",
          "label": { "en": "Payment", "ar": "دفعة" },
          "key": "payment_id",
          "lookup": { "tool": "payments", "action": "get_payment", "arg": "payment_id" },
          "related": [
            { "tool": "payments", "action": "screening_hits", "arg": "payment_id", "label": { "en": "Screening results", "ar": "نتائج الفحص" } },
            { "tool": "payments", "action": "payment_history", "arg": "payment_id", "label": { "en": "History", "ar": "السجل" } }
          ],
          "actions": ["release-payment", "return-payment"]
        },
        {
          "type": "customer",
          "label": { "en": "Customer", "ar": "عميل" },
          "key": "customer_id",
          "lookup": { "tool": "crm", "action": "get_customer", "arg": "customer_id" },
          "related": [
            { "tool": "payments", "action": "list_payments", "arg": "customer_id", "label": { "en": "Recent payments", "ar": "المدفوعات الأخيرة" } }
          ],
          "actions": []
        }
      ],
      "actions": [
        {
          "id": "release-payment",
          "label": { "en": "Release payment", "ar": "الإفراج عن الدفعة" },
          "call": { "tool": "payments", "action": "release_payment" },
          "input": { "payment_id": "{record.key}" },
          "roles": ["payments-ops"]
        },
        {
          "id": "return-payment",
          "label": { "en": "Return to sender", "ar": "إعادة إلى المرسل" },
          "agent": "payments-desk",
          "input": { "payment_id": "{record.key}", "reason": "returned by operations" }
        }
      ]
    }
  ]
}
